import { APP_LOCAL_KEYS } from "@/app/constants/constants";
import { typedLocalStorage } from "@/utils/storage/localStorage";

const getStoredJsonValue = <T>(
  key: (typeof APP_LOCAL_KEYS)[keyof typeof APP_LOCAL_KEYS],
  fallback: T,
): T => {
  const storedValue = typedLocalStorage.getItem(key);

  return (storedValue as T) ?? fallback;
};

export const getToken = (): string | null => {
  return typedLocalStorage.getItem(APP_LOCAL_KEYS.TOKEN);
};

export const getSubdomain = (): string | null => {
  return typedLocalStorage.getItem(APP_LOCAL_KEYS.SUB_DOMAIN);
};

export const getWorkspace = (): string => {
  const workspaceId = getStoredJsonValue<string | null>(
    APP_LOCAL_KEYS.WORKSPACE_ID,
    null,
  );

  const workspaceData = getStoredJsonValue<{ id?: string } | null>(
    APP_LOCAL_KEYS.WORKSPACE_DATA,
    null,
  );

  if (!workspaceId) {
    return workspaceData?.id ?? "";
  }

  return workspaceId;
};

export const getCustomerId = (): string => {
  const storedValue = typedLocalStorage.getItem(APP_LOCAL_KEYS.CUSTOMER_ID);

  if (!storedValue) {
    return "";
  }

  return storedValue;
};

export const getCustomerUserId = (): string => {
  const storedValue = typedLocalStorage.getItem(
    APP_LOCAL_KEYS.CUSTOMER_USER_ID,
  );

  if (!storedValue) {
    return "";
  }

  return storedValue;
};

export const isSuperAdmin = (): boolean => {
  const userData = getStoredJsonValue<{ role?: string }>(
    APP_LOCAL_KEYS.USER_DATA,
    {},
  );

  return userData.role === "SUPERADMIN";
};
